






























import axios from 'axios'
import * as querystring from 'querystring'
import {Component} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import AuthLayout from '@/components/auth/Layout.vue'
import { apiV1UsersPasswordsPath } from '@/rails/routes'

@Component({
  components: {
    AuthLayout
  }
})
export default class PasswordsEdit extends VueBase {
  password = ''
  password_confirmation = ''
  errors = []
  completed = false

  mounted(): void {
  }

  async update(): Promise<void> {
    try {
      const query = querystring.parse(location.search.substr(1))
      await axios.put(apiV1UsersPasswordsPath(), {
        reset_password_token: query['reset_password_token'],
        password: this.password,
        password_confirmation: this.password_confirmation,
      })
      this.completed = true
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response).errors
    }
  }
}
